import 'core-js';
import application from './app';
import {VhtApplicationBootstrapper} from '@vht/react-components';
import i18n from '@vht/react-components/utils/i18n';
import config from './config';

const appId = config.platformManagement.appId;

function loadI18n() {
  return new Promise(resolve => {
    i18n.i18next.loadNamespaces(appId, () => resolve());
  });
}

VhtApplicationBootstrapper.init([application], [loadI18n]);
